module.exports = __webpack_public_path__ + "47334dc2.png";